import React from 'react';

export const beautifulGirlRoute = [
  {
    path: '/beautifulGirl/home',
    component: React.lazy(() => import('@/views/system/beautifulGirl/home')),
    meta: {
      title: '美女'
    }
  }
  // {
  //   path: '/competition/zone',
  //   component: React.lazy(() => import('@/views/competition/zone')),
  //   meta: {
  //     title: '专区'
  //   }
  // },
  /* {
    path: '/competition/live',
    component: React.lazy(() => import('@/views/competition/live')),
    meta: {
      title: '直播'
    }
  } */
];
